<form (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="flex items-center" mat-dialog-title>
        <h2 class="headline m-0 flex-auto">{{data.title}}</h2>
        <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
            <mat-icon svgIcon="mat:close"></mat-icon>
        </button>
    </div>
    <mat-divider class="text-border"></mat-divider>
    <mat-dialog-content class="flex flex-col">
        <div class="flex flex-col sm:flex-row sm:gap-4">
            <mat-form-field class="flex-auto">
                <mat-label>Imagen</mat-label>
                <ngx-mat-file-input formControlName="image" accept=".png,.jpg,.jpeg"
                    (change)="fileChangeListener($event)">
                </ngx-mat-file-input>
                <mat-icon svgIcon="mat:folder" matSuffix></mat-icon>
                <small>Formatos permitidos: .png, .jpg, .jpeg</small>
            </mat-form-field>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close type="button">{{appSettings.DIALOG_BUTTON_CANCEL}}</button>
        <button [disabled]="form.invalid" color="primary" mat-flat-button type="submit">{{data.button}}</button>
    </mat-dialog-actions>
</form>